import{createTheme as r}from"@mui/material/styles";import{base as e}from"./base";const m=r({...e,palette:{...e.palette,mode:"dark",primary:{light:"#064267",main:"#0C2E3D",dark:"#333333"}}});export{m as dark};
//# sourceMappingURL=dark.js.map
